import { truncateString, truncateUrl, userFullName } from "helpers/common";
import { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useCreateNoteMutation, useDeleteNoteMutation, useGetNoteQuery, useUpdateNoteMutation } from "store/services/note";
import moment from "moment";
import p1 from "Assets/images/user.png";
import imageLoader from 'Assets/images/imageLoader.gif'
import { useSelector } from "react-redux";
import ViewAllNotes from "components/Modals/ViewAllNotesPop";
import { CommonToolTip, NoRecordFound } from "components/Common/Common";
import LoadingOverlay from "components/shared/LoadingOverlay";

const singleNote = { note: "", disable: false };

const NotesComponentV2 = ({ client_id, module, heading = "Notes", buttonName = "Create Note", v2 = false }) => {
    const [showAllNotes, setShowAllNotes] = useState(false);

    // notes
    const { data: notes, isLoading, isFetching } = useGetNoteQuery({ clientId: client_id, moduleName: module }, { skip: !client_id });
    const [isCreate, setIsCreate] = useState(false);
    const notesArray = notes?.length ? notes?.map(i => ({ ...i, disable: true })).sort((a, b) => a.pin_top == "Y" ? -1 : 1) : [{ ...singleNote }];
    // Get pinned notes first
    const pinnedNotes = notes?.filter(x => x?.pin_top === "Y") || [];

    // Get non-pinned notes
    const unpinnedNotes = notes?.filter(x => x?.pin_top !== "Y") || [];

    // Combine — pinned first, then unpinned
    const sortedNotes = [...pinnedNotes, ...unpinnedNotes];

    const noteToShow = notes?.find(x => x?.pin_top == "Y") || notes?.find(x => x?.id);

    // Take only the first 4 notes
    const notesToShows = sortedNotes.slice(0, 4);

    console.log('notes check', notes)
    return (
        <div className="w-100">
            {(isLoading || isFetching) && <LoadingOverlay />}
            <ViewAllNotes
                isCreate={isCreate}
                show={showAllNotes}
                setShow={setShowAllNotes}
                notes={notesArray}
                client_id={client_id}
                module={module}
            />
            <Row className="align-items-center my-3" >
                <Col lg="12" >
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6 className="m-0 themeBlue fw-semibold">{heading}</h6>
                        {/* <Button
                            className="commonBtn"
                            style={{ padding: "0", height: "35px", minWidth: "100px" }}
                            onClick={() => { setIsCreate(true); setShowAllNotes(true) }}

                        >{buttonName}</Button> */}
                        <button
                            onClick={() => { setIsCreate(true); setShowAllNotes(true) }}
                            type="submit"
                            className="d-flex align-items-center gap-2 justify-content-center discharge-screen"
                        // isLoading={submitReportLoading || submitting}
                        >
                            Create
                        </button>
                    </div>
                </Col>
                <Col lg="12">
                    <Row>
                        {notesToShows?.length > 0 ? notesToShows?.map((item) => <Col lg="12 my-1" sm="12">
                            <div className="student-details-main-box p-3 shadow" style={{ background: "rgb(253 217 202 / 31%)", border: "1px solid rgb(61, 160, 170)" }}>
                                <div className="student-details-main-box-inner">
                                    <div className="student-details-main-box-heading"
                                    >
                                    </div>
                                </div>

                                <p style={{ fontSize: "14px", fontWeight: "700" }}>
                                    <CommonToolTip
                                        component={<h6
                                            style={{
                                                textOverflow: "ellipsis",
                                                overflow: "hidden",
                                                fontSize: "14px",
                                            }}

                                            className="m-0 fw-bold themeBlue"
                                        >
                                            {truncateString(item?.note, 150)}
                                        </h6>}
                                        text={item?.note}
                                    />
                                </p>

                                <div className="student-details-main-notes" style={{ fontSize: "12px" }}>
                                    <div className="student-details-inner-notes d-flex align-items-center gap-2">
                                        <img
                                            src={item?.noteOwner?.therapist_detail?.profile_picture === null ? p1 : (item?.noteOwner?.therapist_detail?.profile_picture == "undefined" ? imageLoader : item?.noteOwner?.therapist_detail?.profile_picture ? item?.noteOwner?.therapist_detail?.profile_picture : p1)}
                                            // src={noteToShow?.noteOwner?.therapist_detail?.profile_picture || p1}
                                            alt=""
                                            className="img-fluid object-fit-cover rounded-circle border border-white"
                                            style={{ height: 30, width: 30 }}
                                        />
                                        {userFullName(item?.noteOwner)}
                                    </div>
                                    <div className="student-details-inner-notes">
                                        {moment(item?.createdAt).format("DD/MM/YYYY")}
                                    </div>
                                </div>
                            </div>
                        </Col>) : <div className="px-2"><NoRecordFound showBorder /></div>}
                        <Col lg="12" sm="12" className="mt-2">
                            <div className="w-100 d-flex justify-content-end">
                                <p
                                    style={{ color: "#b46c9f", fontSize: "14px", cursor: "pointer" }}
                                    onClick={() => { setIsCreate(false); setShowAllNotes(true) }}
                                >
                                    {"Show all"}
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row >
        </div >
    );

};

export default NotesComponentV2;